import { tryCatchHelper } from '../../../helpers';
import { ALL_ESTATUS } from './EstatusReducer';
import { allEstatusService } from './EstatusService';

export const allEstatusAction = async (dispatch) => {
  try {
    const res = await allEstatusService();
    dispatch({
      type: ALL_ESTATUS,
      payload: res.data,
    });
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
